import loader from './lib/Loader';

import(/* webpackPrefetch: true */ './icons');
loader('typesense/instantsearch', '.product-archive');
loader('slider', '.slider');
loader('sliders/product-image', '.product-imageslider');
loader('miniCart', '.sidebar-mini-cart');
loader('accordion', '.accordion');
loader('navbar', '.header__navigation');
loader('menu', '.menu--mobile');
loader('letter', '.wordlist');
loader('scroll', '.header');
loader('googleMaps', '.maps-contact');
loader('bundled', '.product-type-bundle');
loader('stickyCart', '.sticky-cart');
loader('popup', '.my-account-menu-overlay');
loader('wishlist', '.wishlist-mezaldi');
loader('footer', '.footer');
loader('loadMore', '.load-more');
loader('myAccount', '.woocommerce-form');
loader('gtm');
loader('checkbox', '.wcpf-title-container');
loader('checkout', '.woocommerce-checkout');
loader('foldout', '.foldout');
loader('salesIcon', '.product-card-tags');
loader('gformDatalayer', '.footer__form');
loader('mobileSearch', '.search__field');
